import { otmsHttp, noPrefixHttp, scHttp, bfsUserWebHttp,exportWeb,wmsHttp } from '@/utils/http/index.js'

/**
 * 获取订单列表
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/9932
 */
export function fetchOrderList(data, params) {
    return otmsHttp.request({
        url: '/unify/order/v2/page',
        method: 'post',
        data,
        params,
        noEnterprise:true
    })
}

/**
 * 获取货物品类
 * 货物品类的参数固定 cargoType，不知道接口在哪里，具体参数是什么
 */
export function fetchCargoType() {
    return noPrefixHttp.request({
        url: '/hope-saas-base-web/bmsDataDictionary/selectList',
        method: 'post',
        data: {
            dictionaryType: "cargoType",
            status: 1
        }
    })
}

/**
 * 取消订单
 * 
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/9658
 */
export function cancelOrder(data) {
    return otmsHttp.request({
        url: '/unify/order/v2/batch/cancel',
        method: 'post',
        data
    })
}

/**
 * 客户订单导入
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8474
 */
export function importOrder(file) {
    return otmsHttp.request({
        url: '/order/customer/import',
        method: 'post',
        data: file,
    })
}

/**
 * 客户订单失败数据下载
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8476
 */
export function featchFailData(batchId) {
    return otmsHttp.request({
        url: '/order/customer/fetchFailData',
        method: 'post',
        responseType: 'blob',
        data: { batchId },
    });
}

/**
 * 获取订单详情
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/9928
 */
export function featchOrderDetail(data) {
    return otmsHttp.request({
        url: '/unify/order/v2/detail',
        method: 'post',
        data,
    });
}

/**
 * 订单日志
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8558
 */
export function featchOrderLogs(bizNo, bizType) {
    return otmsHttp.request({
        url: '/customer/order/node/log',
        method: 'post',
        data: {
            bizNo,
            bizType
        },
    });


}

export function getLogs(bizNo, bizType) {
    return otmsHttp.request({
        url: '/customer/v2/unify/node/log',
        method: 'post',
        data: {
            bizNo,
            bizType
        },
    });


}
// 获取派车详情
export function dispatchInfo(data) {
  return otmsHttp.post('/order/dispatch_info', data)
}

// 根据订单号查询订单详情
export function getOrderDetail(data) {
  return otmsHttp.post('/unify/order/v2/detail', data)
}

/**
 * @description: 创建下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/9648
 */
export function createWarehouseOrder(data) {
  return otmsHttp.post('/unify/order/v2/create', data)
}

/**
 * @description: 编辑下单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/9778
 */
export function updateWarehouseOrder(data) {
  return otmsHttp.post('/unify/order/v2/update', data)
}

/**
 * @description: 获取站点列表
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8586
 */
export function getStationList(data, params) {
  return otmsHttp.post('/customer/station/page', data, {params})
}

/**
 * @description: 创建站点
 */
export function createStation(data) {
  return otmsHttp.post('/customer/station/create', data)
}
// 获取运单节点日志
export function orderLogList(data) {
    return otmsHttp.post('/order/log/list', data)
}
/**
 * 数仓 查询车辆时间段内的GPS信息
 * @param {Objcet} params
 * params = {
 *   "vehicle":"川MP3969" 需要查询的车牌,仅支持单车查询
 *    "starttime":"2019-10-08 12:00:00" 查询时间段的起始时间，格式为yyyy-mm-dd hh24:mi:ss。starttime不能比endtime大。
 *    "endtime":"2019-10-08 12:10:00" 查询时间段的结束时间，格式为yyyy-mm-dd hh24:mi:ss。starttime不能比endtime大。
 * }
 */
export function getdinnercarmsg(params) {
    return scHttp.get('/interface/gps/getdinnercarmsg', {},{params})
  }
  
/**
 * 订单导出
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8802
 */
export function orderExport(data) {
    return otmsHttp.request({
        url: '/order/customer/export',
        method: 'post',
        data
    });
}

/**
 * 订单批量删除
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8802
 */
export function orderBatchDeletion(data) {
    return otmsHttp.request({
        url: '/oms_plus/customer/order/delete',
        method: 'post',
        data
    });
}
/**
 * 项目查询
 * 
 */
export function getOrganization(data, params) {
    return otmsHttp.post({
      url: '/customer/project_list',
      method: 'post',
      data,
      params
    })
  }

// 根据账号查询组织列表
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/9448
export function projectList(data) {
    return bfsUserWebHttp.post({
        url: '/bfs-user/account_org/organization/list',
        method: 'post',
        data,
    })
}

/**
 * 获取仓库列表
 *  
 */
 export function getWareHouse(data,params) {
    return otmsHttp.request({
        url: '/customer/ext/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 获取货主以及下级货主列表
 *  
 */
 export function getCustomerList(data, params) {
    return otmsHttp.request({
        url: '/customer/bind_children_page',
        method: 'post',
        data,
        params
    })
}

/**
 * 上传多文件
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/16457
 */
 export function multipleFiles(data) {
    return otmsHttp.request({
        url: '/order/file/multi/upload',
        method: 'post',
        data,
    })
}

/**
 * 多文件打包下载
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/16515
 */
 export function downMultipleFiles(data) {
    return otmsHttp.request({
        url: '/order/file/package/download',
        method: 'post',
        data,
    })
}
/**
 * 单文件下载
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/16563
 */
 export function downOneFiles(data) {
    return otmsHttp.request({
        url: '/order/file/download',
        method: 'post',
        data,
    })
}

/**
 * 重新推送
 */
 export function afreshAccept(data) {
  return otmsHttp.request({
      url: '/oms_plus/unify/order/retry/push',
      method: 'post',
      data,
  })
}


/**
 * 仓订单导出
 */
 export function wareHouseOrderExport(data) {
  return exportWeb.request({
      url: '/unify/order/v2/export',
      method: 'post',
      data,
  })
}

/**
 * @description: 一装多卸创建订单
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/23283
 */
 export function createWarehouseMultipleOrder(data) {
  return otmsHttp.post('/unify/order/warehouse/create', data)
}


/**
 * @description: 仓配一装多卸编辑 -目前只支持出库
 * @api文档 https://yapi.ops.yunlizhi.cn/project/194/interface/api/23283
 */
 export function updateWarehouseMultipleOrder(data) {
  return otmsHttp.post('/unify/order/warehouse/update', data)
 }

 /**
 * @description: 入库信息表 根据ID获取
 * @api文档：https://yapi.ops.yunlizhi.cn/project/382/interface/api/13274
 */
export function inboundOrderDetail(data) {
  return wmsHttp.post('/warehouse_management_system/receipt_order/detail', data);
}
/**
 * @description:获取入库验收差异数据详情
 * @api文档：https://yapi.ops.yunlizhi.cn/project/382/interface/api/23887
 */
 export function getInWarehouseDiff(data) {
  return wmsHttp.post('/warehouse_management_system/receipt_acceptance_diff/detail', data);
 }

 /**
 * 查询货主列表
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/12400
 */
export function getShipperInfoByCode(data) {
  return wmsHttp.post('/warehouse_foundation/shipper/v2/page', data);
}

/**
 * POI列表
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/8552
 */
 export function getPoiList(data) {
    return bfsUserWebHttp.post('/base_plus/poi/list', data)
  }

  /**
 * 修改订单地址
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/29702
 */
export function updateAddress(data) {
    return bfsUserWebHttp.post('/oms_plus/address/update/approval', data)
}

/**
 * 获取修改详情
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/29711
 */
export function getAddressDetail(data) {
return bfsUserWebHttp.post('/oms_plus/address/update/detail', data)
}

/**
 * 发送验证码
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/cat_15138
 */
export function sendCode(data) {
    return otmsHttp.post('/oms_plus/address/update/send/sms', data)
}

/**
 * 项目列表
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/30038
 */
export function getProjectList(data) {
    return otmsHttp.post('/crm-plus/project/list', data)
}


/**
 * 仓费目明细查询
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/49068
 */
export function warehouseOrderCostList(data) {
    return otmsHttp.post('/oms_plus/warehouse/order/cost/list', data)
}